import React from "react";
// custom typefaces
import "typeface-montserrat"; // import "prismjs/themes/prism.css";
import { GlobalState } from "../src/components/gallery/globalState";
export var wrapRootElement = function wrapRootElement(_ref) {
    var element = _ref.element;
    return /*#__PURE__*/ React.createElement(GlobalState, null, element);
};
